/** @jsx jsx */
import { h, FunctionalComponent, Fragment } from 'preact'
import { jsx } from '@emotion/core'
import { getDefaultStylesObj } from './storyLink.styles'
import { useSiteVars } from '../../themes/useSiteVars'

interface StoryLinkProps {
    text: string
    url: string
    callToAction: string
    theme: 'dark' | 'light'
    preview?: boolean
}

const StoryLink: FunctionalComponent<StoryLinkProps> = ({ text, url, callToAction, theme, preview }) => {
    const siteVars = useSiteVars()
    const storyLinkStyles = getDefaultStylesObj(theme, siteVars, preview)

    const smartTrimWithEllipses = (str: string, maxLen: number, separator = ' ') => {
        if (!str || str.length <= maxLen) return str
        return str.substr(0, str.lastIndexOf(separator, maxLen)).concat('...')
    }

    return (
        <Fragment>
            <a href={url} css={storyLinkStyles.root} target="_top">
                <div css={storyLinkStyles.headerWrapper}>
                    <span css={storyLinkStyles.header}>{callToAction}: </span>
                    <span>{smartTrimWithEllipses(text, 65)}</span>
                </div>
                <div css={storyLinkStyles.arrow}>
                    <span css={storyLinkStyles.arrowLeftTop} />
                    <span css={storyLinkStyles.arrowLeftBottom} />
                    <span css={storyLinkStyles.arrowRightTop} />
                    <span css={storyLinkStyles.arrowRightBottom} />
                </div>
            </a>
        </Fragment>
    )
}

export default StoryLink
